export default __webpack_public_path__ + "static/media/dialog-corner-me.c59ededf.svg";